import { pageLocale } from "./locale";

//This constants for TUG Front, Side, Gait and Balance ;
const {
  tug_time,
  summary,
  speed,
  step_length,
  steps_per_minute,
  head_wobbling,
  shoulder_balance,
  hip_balance,
  sit_to_standup_time,
  attempts_to_rise,
  s,
  second,
  steps_min,
  degree,
  stand_to_sit_time,
  right_left_step_symmetry,
  gait_smoothness,
  foot_clearance,
  trunk_sway,
  turning_time,
  steps_during_turn,
  joint_angles_knee,
  joint_angles_hip,
  foot_placement,
  postural_control,
} = pageLocale("newreport");
export const limits = {
  fronttugTime: {
    min: 8,
    max: 17,
    //top: 30,
    name: tug_time,
    unit: second,
    green: 12,
    red: 14,
    yAxis: [0, 10, 20, 30, 40],
  },
  frontgaitSummary: {
    min: 0,
    max: 6,
    //top: 10,
    name: summary,
    unit: "",
    green: 4,
    red: 2,
    yAxis: [0, 2, 4, 6],
  },

  frontgaitSpeed: {
    min: 30,
    max: 60,
    //top: 150,
    name: speed,
    unit: "(cm/s)",
    green: 50,
    red: 40,
    yAxis: [0, 50, 100, 150, 200],
  },
  frontgaitStepLength: {
    min: 30,
    max: 60,
    //top: 150,
    name: step_length,
    unit: "(cm)",
    green: 50,
    red: 40,
    yAxis: [0, 50, 100, 150, 200],
  },
  frontgaitStepPerMinute: {
    min: 0,
    max: 100,
    top: 100,
    name: steps_per_minute,
    unit: `(${steps_min})`,
    green: 50,
    red: 40,
    yAxis: [0, 50, 100, 150, 200],
  },
  frontBalancesummary: {
    min: 0,
    max: 3,
    top: 6,
    name: summary,
    unit: "",
    green: 4,
    red: 2,
    yAxis: [0, 2, 4, 6, 8],
  },
  frontbalanceHeadWobbling: {
    min: 0,
    max: 3,
    //top: 60,
    name: head_wobbling,
    unit: "(cm)",
    green: null,
    red: null,
    yAxis: [0, 1, 2, 3],
  },
};
export const columnFront = {
  frontShoulderBalance: {
    min: -10,
    max: 10,
    name: shoulder_balance,
    unit: `(${degree}  θ)`,
    green: "",
    red: "",
    yAxis: [0, 5, 10, -5, -10],
  },
  frontHipBalance: {
    min: -10,
    max: 10,
    name: hip_balance,
    unit: `(${degree}  θ)`,
    green: "",
    red: "",
    yAxis: [0, 25, 50, 75, 100],
  },
};

export const sidelimits = {
  fronttugTime: {
    min: 8,
    max: 17,
    //top: 30,
    name: tug_time,
    unit: second,
    green: 12,
    red: 14,
    yAxis: [0, 10, 20, 30, 40],
  },
  frontgaitSummary: {
    min: 0,
    max: 6,
    //top: 10,
    name: summary,
    unit: "",
    green: 4,
    red: 2,
    yAxis: [0, 2, 4, 6],
  },

  frontgaitSpeed: {
    min: 30,
    max: 60,
    //top: 150,
    name: speed,
    unit: "(cm/s)",
    green: 50,
    red: 40,
    yAxis: [0, 50, 100, 150, 200],
  },
  frontgaitStepLength: {
    min: 30,
    max: 60,
    //top: 150,
    name: step_length,
    unit: "(cm)",
    green: 50,
    red: 40,
    yAxis: [0, 50, 100, 150, 200],
  },
  frontgaitStepPerMinute: {
    min: 0,
    max: 100,
    // top: 100,
    name: steps_per_minute,
    unit: `(${steps_min})`,
    green: 50,
    red: 40,
    yAxis: [0, 50, 100, 150, 200],
  },
  sideBalancesummary: {
    min: 0,
    max: 3,
    name: summary,
    unit: "",
    green: 4,
    red: 1,
    yAxis: [0, 2, 4, 6, 8],
  },
  timeToStandUp: {
    min: 0,
    max: 1,
    name: sit_to_standup_time,
    unit: s,
    green: 1,
    red: 0,
    yAxis: [0, 2, 4, 6, 8],
  },
  attemptsToRise: {
    min: 0,
    max: 2,
    name: attempts_to_rise,
    unit: "",
    green: 2,
    red: 0,
    yAxis: [0, 2, 4, 6, 8],
  },
  // New V5 metrics
  standToSitTime: {
    min: 0,
    max: 3,
    name: stand_to_sit_time,
    unit: s,
    green: null,
    red: null,
    yAxis: [0, 1, 2, 3, 4],
  },
  sitToStandTime: {
    min: 0,
    max: 3,
    name: sit_to_standup_time,
    unit: s,
    green: null,
    red: null,
    yAxis: [0, 1, 2, 3, 4],
  },
  rightLeftStepSymmetry: {
    min: 0,
    max: 2,
    name: right_left_step_symmetry,
    unit: "",
    green: null,
    red: null,
    yAxis: [0, 1, 2, 3],
  },
  gaitSmoothness: {
    min: 0,
    max: 2,
    name: gait_smoothness,
    unit: "",
    green: null,
    red: null,
    yAxis: [0, 1, 2, 3],
  },
  footClearance: {
    min: 0,
    max: 5,
    name: foot_clearance,
    unit: "(cm)",
    green: null,
    red: null,
    yAxis: [0, 2, 4, 6],
  },
  trunkSway: {
    min: 0,
    max: 5,
    name: trunk_sway,
    unit: "",
    green: null,
    red: null,
    yAxis: [0, 2, 4, 6],
  },
  turningTime: {
    min: 0,
    max: 5,
    name: turning_time,
    unit: s,
    green: null,
    red: null,
    yAxis: [0, 1, 2, 3, 4, 5],
  },
  stepsDuringTurn: {
    min: 0,
    max: 10,
    name: steps_during_turn,
    unit: "",
    green: null,
    red: null,
    yAxis: [0, 2, 4, 6, 8, 10],
  },
  jointAnglesKnee: {
    min: 0,
    max: 90,
    name: joint_angles_knee,
    unit: `(${degree})`,
    green: null,
    red: null,
    yAxis: [0, 30, 60, 90],
  },
  jointAnglesHip: {
    min: 0,
    max: 90,
    name: joint_angles_hip,
    unit: `(${degree})`,
    green: null,
    red: null,
    yAxis: [0, 30, 60, 90],
  },
  footPlacement: {
    min: 0,
    max: 30,
    name: foot_placement,
    unit: "(cm)",
    green: null,
    red: null,
    yAxis: [0, 10, 20, 30],
  },
  posturalControl: {
    min: 0,
    max: 5,
    name: postural_control,
    unit: "",
    green: null,
    red: null,
    yAxis: [0, 1, 2, 3, 4, 5],
  },
};
